import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0a1 1 0 0 1 1 1v2.032l-.001.021-.002.03A6.002 6.002 0 0 1 16 9c0 3.093.625 4.312 1.599 6.21l.034.068c.17.33-.07.722-.442.722H2.809a.496.496 0 0 1-.442-.722l.034-.068C3.375 13.312 4 12.093 4 9a6.002 6.002 0 0 1 5.003-5.918l-.002-.04A.835.835 0 0 1 9 3V1a1 1 0 0 1 1-1zm2 18a2 2 0 0 1-4 0h4z"
});

var SvgNotificationMajor = function SvgNotificationMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgNotificationMajor as S };
